import { AccountSubdomainFormVM } from './account-subdomain-form.viewmodel';
import { withViewModel } from '../../../infrastructure/components/with-view-model';
import { AccountSubdomainFormPresentation } from './account-subdomain-form.presentation';

interface IProps {
    vm: AccountSubdomainFormVM;
}

const AccountSubdomainFormContainer = withViewModel(
    AccountSubdomainFormPresentation,
    (props: IProps) => {
        return props.vm;
    }
);

export { AccountSubdomainFormContainer as AccountSubdomainForm };